export default function MySQL_REPLACE() {
  return (
    <div>
      <h2>MySQL_REPLACE</h2>    </div>
  );
}